import { type FC } from "react";

/**
 * TradingApp - landing page for the Trading workspace
 *
 * @returns TradingApp component
 *
 */
export const TradingApp: FC = () => {
  return <div className="p-4">Trading Workspace</div>;
};
